module.exports = __webpack_public_path__ + "static/media/homefinal@2x.b3a03bd8.png";